import React from "react";

// types
// import { ErrorWarning } from "../../../store/types/misc";
import img from "../../../constant";

type TextInputProps = {
  placeholder: string;
  prefix?: React.ReactNode;
  className?: string;
  value?: string | number | [];
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void | undefined;
  name: string;
  type?: "text" | "password" | "file";
  status?: string;
  error?: string;
  label?: string;
  container?: string;
  required?: boolean;
  showIcon?: boolean;
  add?: () => void;
  remove?: () => void;
  rows?: number;
  min?: number;
  max?: number;
};

const TextInputBox: React.FC<TextInputProps> = (props) => {
  // Use status or error prop to determine if there's an error and apply red border
  const hasError = (props.status && props.status.length > 0) || !!props.error;
  const errorMessage =
    props.error ||
    (props.status && props.status.length > 0 ? props.status : "");
  const borderColor = hasError ? "border-[red]" : "border-[#0B60D6]";
  const { showIcon = false, add, remove, rows } = props;
  // [#e8e8e8];

  return (
    <div className={`${props.container} mb-3 font-abel`}>
      <div className="flex justify-between items-end">
        {props.label && (
          <label className="text-[#1E1E1E] text-[15px]">
            {props.label}{" "}
            {props.required && <span className="text-[red]">*</span>}
          </label>
        )}
        {showIcon && (add || remove) ? (
          <div className="cursor-pointer flex">
            {remove && (
              <div
                onClick={remove}
                className="mr-2 flex items-center  bg-[grey] text-white pl-1 pr-2 py-1 rounded-6"
              >
                <img src={img.remove} alt="Remove" />{" "}
                <span className="pl-1">Remove</span>
              </div>
            )}
            {add && (
              <div
                onClick={add}
                className="cursor-pointer flex items-center bg-primary text-white pl-1 pr-2 py-1 rounded-6"
              >
                <img src={img.add} alt="Add" />{" "}
                <span className="pl-1">Add</span>
              </div>
            )}
          </div>
        ) : null}
      </div>
      <div>
        <textarea
          placeholder={props.placeholder}
          value={props.value}
          name={props.name}
          onChange={props.onChange}
          rows={props.rows}
          minLength={props.min}
          className={`text-[15px] mt-1 py-2 px-4 placeholder:text-[#98A2B3] placeholder:font-abel placeholder:text-[15px] font-abel hover:border-[#243677] focus:border-[#243677] w-full h-full rounded-[10px] border ${borderColor} ${props.className}`}
        ></textarea>
        {/* Display error message if error exists */}
        {/* {hasError && errorMessage && (
          <p className="text-[red] text-[12px] mt-1">{errorMessage}</p>
        )} */}
      </div>
    </div>
  );
};

export default TextInputBox;
